import { render, staticRenderFns } from "./Startup.vue?vue&type=template&id=55bb854c"
import script from "./Startup.vue?vue&type=script&lang=ts"
export * from "./Startup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports